<template>
	<div>
		<data-list
			style="margin-top: 10px"
			:table-style="{ name: 'mixture' }"
			:data="data"
			:columns="columns"
			:loading="loading"
			:page="page"
			:page-size="page.pageSize"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
			@sort-change="sortChange"
			@expand-change="expandChange"
			rowKey="id"
			:expandRowKeys="expandRowKeys"
		></data-list>
	</div>
</template>

<script>
import api from '@/backend/apiConfig/apiConfig';
import listPageCreate from '@/mixins/listPageCreate';
const page = listPageCreate({
	searchConfig: {
		api: api.service.getServiceList,
		method: 'POST',
	},
	getQuery(obj, that) {
		return _.assign(obj, { customerId: that.$route.query.id });
	},
});
export default {
	mixins: [page],
	props: {
		columns: Array,
	},
	data() {
		return {
			expandRowKeys: [],
		};
	},
	methods: {
		expandChange({ arr }) {
			this.expandRowKeys = [];
			arr.map(item => this.expandRowKeys.push(item.id));
		},
	},
	mounted() {
		this.query();
	},
};
</script>

<style></style>
